<div class="ai-home">
  <main class="main">
    <!-- Greeting + KPIs -->
    <section class="hero">
      <h1>What do you want to do today?</h1>
      <!-- <div class="kpis">
        <div class="kpi" *ngFor="let k of kpis">
          <div class="val">{{ k.value }}</div>
          <div class="lab">{{ k.label }}</div>
          <div class="hint" *ngIf="k.hint">{{ k.hint }}</div>
        </div>
      </div> -->
    </section>

    <!-- Prompt card -->
    <section class="prompt-card" role="search">
      <form (ngSubmit)="onSubmit()">
        <input type="text" [value]="prompt()" (input)="prompt.set(($any($event.target)).value)"
            placeholder="Ask the valuation assistant..." />
        <button type="submit" class="send" title="Submit">➤</button>
      </form>

      <div class="suggestions">
        <button class="chip" *ngFor="let q of quicks" (click)="useQuick(q)">
          {{ q.text }}
        </button>
      </div>
    </section>

    <!-- Pipeline -->
    <section class="pipeline">
      <h2>Typical pipeline</h2>
      <div class="steps">
        <a *ngFor="let p of pipeline" class="step" [routerLink]="p.to">
          <div class="badge" aria-hidden="true"></div>
          <div class="txt">
            <div class="name">{{ p.name }}</div>
            <div class="desc">{{ p.desc }}</div>
          </div>
        </a>
      </div>
    </section>

    <!-- Recent work -->
    <!-- <section class="recent">
      <h2>Recent work</h2>
      <div class="cards">
        <a class="card" *ngFor="let r of recent" routerLink="/valuations">
          <div class="title">{{ r.title }}</div>
          <div class="meta">{{ r.meta }}</div>
        </a>
      </div>
    </section> -->
  </main>
</div>
